import {
    handle,
    loader,
    default as ProfessionalContactRoute,
} from '~/routes/_app.professional.$urlSegment.contact';

export { loader, handle };
export default ProfessionalContactRoute;
